export const MENU_ITEM_ID_TEXT_MAP = {
  recent: 'RECENT',
  tools: 'TOOLS',
  image_models: 'IMAGE_MODELS',
  video_models: 'VIDEO_MODELS',
  threed_models: 'THREE_D_MODELS',
  custom_models: 'CUSTOM_MODELS',
  non_model_edit: 'NON_MODEL_EDIT',
  iterators: 'ITERATORS',
  helpers: 'HELPERS',
  frequently_used: 'FREQUENTLY_USED',
  matting: 'MATTING',
  text_tools: 'TEXT_TOOLS',
  data_types: 'DATA_TYPES',
  generate_image_from_text: 'GENERATE_IMAGE_FROM_TEXT',
  generate_vector_from_text: 'GENERATE_VECTOR_FROM_TEXT',
  edit_image: 'EDIT_IMAGE',
  generate_image_from_image: 'GENERATE_IMAGE_FROM_IMAGE',
  enhance_image: 'ENHANCE_IMAGE',
  generate_video_from_text_or_image: 'GENERATE_VIDEO_FROM_TEXT_OR_IMAGE',
  generate_video_from_video: 'GENERATE_VIDEO_FROM_VIDEO',
  lip_sync: 'LIP_SYNC',
  enhance_video: 'ENHANCE_VIDEO',
  generate_3d_from_text_or_image: 'GENERATE_3D_FROM_TEXT_OR_IMAGE',
  community_models: 'COMMUNITY_MODELS',
  userModels: 'USER_MODELS',
  saved: 'SAVED',
  saved_models: 'SAVED_MODELS',
  saved_nodes: 'SAVED_NODES',
};
